import dayjs, { Dayjs } from 'dayjs';
import { ListPost } from 'types/PostDetail';

/**
 * Gets the earliest date from a list of posts.
 * Returns today's date if no valid dates are found.
 */
export const getEarliestPostDate = (posts: ListPost[]): Dayjs => {
  if (posts.length === 0) return dayjs();

  const dates = posts
    .map((post) => post.date)
    .filter((date): date is string => !!date)
    .map((date) => dayjs(date));

  if (dates.length === 0) return dayjs();

  return dates.reduce((earliest, current) =>
    current.isBefore(earliest) ? current : earliest,
  );
};
